import { CENTER } from "../constants/mainAPI";
import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import { CenterDataCreate, CentersSuccessResponse, CenterSuccessResponse } from "../types/api/center";
import { toFormData } from "../utils/toFormData";

export const getCenters = (
    callback?: (resp: CentersSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(CENTER, true, searchParams, callback, errorCallback);
};

export const getCenter = (
    centerId: number | undefined,
    callback?: (resp: CenterSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}`, true, {}, callback, errorCallback);
};

export const createNewCenter = (
    data: CenterDataCreate,
    callback?: (resp: CenterSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPostRequest(CENTER, true, formData, {}, callback, errorCallback);
};

export const editCenter = (
    centerId: number | undefined,
    data: CenterDataCreate,
    callback?: (resp: CenterSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPutRequest(`${CENTER}/${centerId || 0}`, true, formData, {}, callback, errorCallback);
};

export const deleteCenter = (
    centerId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}`, true, {}, callback, errorCallback);
};
